import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null; // If empty, return null (valid)

    const password = control.value;

    // Define password criteria
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isMinLength = password.length >= 12;

    // Store failed criteria in an object
    const errors: any = {};
    if (!hasLowercase) errors.lowercase = true;
    if (!hasUppercase) errors.uppercase = true;
    if (!hasNumber) errors.number = true;
    if (!hasSpecialChar) errors.specialChar = true;
    if (!isMinLength) errors.minLength = true;

    if (Object.keys(errors).length != 0) {
      errors.passwordRequirements = true;
  }

    // Return errors if any criteria are not met
    return Object.keys(errors).length ? errors : null;
  };
}
